<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex
        xs12
        md6>
        <MaterialCard
          dark
          hover
          color="busie"
          title="Login">
          <StandardForm
            ref="form"
            @submit="submit">
            <StandardInput
              v-model="payload.username"
              icon="mdi-account-circle"
              label="Username" />
            <StandardInput
              v-model="payload.password"
              icon="mdi-lock"
              label="Password"
              type="password"/>
            <CardActions>
              <StandardButton
                text="Login"
                @click.native="$refs.form.$emit('submit')" />
            </CardActions>
          </StandardForm>
        </MaterialCard>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import removeItemByKey from '../utils/removeItemByKey'
import MaterialCard from '@/components/material/Card'
import StandardInput from '../components/busie/StandardInput'
import StandardForm from '../components/busie/StandardForm'
import StandardButton from '../components/busie/StandardButton'
import CardActions from '../components/busie/CardActions'

export default {
  components: {
    StandardInput,
    MaterialCard,
    StandardForm,
    StandardButton,
    CardActions
  },
  props: {},
  data () {
    return {
      payload: this.createFreshForm(),
      apiCalls: [
        'login',
        'dispatch',
        'operator',
        'quotes',
        'dates',
        'amenities',
        'email-templates',
        'rates',
        'users',
        'stops'
      ]
    }
  },
  mounted () {
    if (this.isLoggedIn) {
      this.redirect()
    }
  },
  computed: {
    ...mapGetters('auth', [ 'isLoggedIn', 'token' ]),
    ...mapGetters('dispatch', ['operator'])
  },
  methods: {
    submit () {
      this.toggleLoading()
      return this.login(this.payload).then( async res => {
        this.updateProgress(1/this.apiCalls.length)
        const { range_user } = res.data
        this.setUser(range_user);
        await this.getDispatch(range_user.location)
        this.updateProgress(2/this.apiCalls.length)
        const operatorId = await this.getOperator(this.operator)
        this.updateProgress(3/this.apiCalls.length)
        const quotesQs = `?trip__dispatch__id=${range_user.location}`
        await this.getQuotes(quotesQs)
        this.updateProgress(4/this.apiCalls.length)
        const datesQs = `?dispatch__id=${range_user.location}`
        await this.getDates(datesQs)
        this.updateProgress(5/this.apiCalls.length)
        const amenitiesQs = `?operator__id=${operatorId}`;
        await this.getAmenities(amenitiesQs)
        this.updateProgress(6/this.apiCalls.length)
        const templatesQs = `?operator__id=${operatorId}`;
        await this.getTemplates(templatesQs)
        this.updateProgress(7/this.apiCalls.length)
        await this.fetchTypes(`?operator=${operatorId}`)
        this.updateProgress(8/this.apiCalls.length)
        const usersQs = `?location__id=${range_user.location}`
        await this.fetchUsers(usersQs)
        this.updateProgress(9/this.apiCalls.length)
        const stopsQs = `?trip__dispatch=${range_user.location}`
        await this.fetchAllStops(stopsQs)
        // const ratesQs = `?dispatch__id=${range_user.location}`
        // await this.getRates(ratesQs)
        // const integrationsQs = `?operator=${operatorId}`
        // const headers = { Authorization: this.token }
        // this.fetchIntegrations(integrationsQs, headers)
        this.updateProgress(10/this.apiCalls.length)
        const vm = this
        await new Promise(resolve => setTimeout(
          () => {
            vm.toggleLoading()
            vm.updateProgress(0)
            vm.redirect()
            resolve()
          }, 200)
        )
      }).catch( async e => {
        this.updateProgress(Infinity);
        const vm = this;
        await new Promise(resolve => setTimeout(
          () => {
            vm.toggleLoading()
            vm.updateProgress(0)
            vm.raiseError(e)
            resolve()
          }, 200)
        )
      });
    },
    redirect () {
      this.createFreshForm()
      this.$router.replace(this.$route.query.redirect || '/dashboard')
    },
    createFreshForm: () => {
      // TODO: Change back to null vals
      return {
        username: null,
        password: null
      }
    },
    ...mapActions('auth', ['login']),
    ...mapActions('user', ['setUser']),
    ...mapActions('app', ['toggleLoading', 'updateProgress', 'raiseError']),
    ...mapActions('quotes', { getQuotes: 'fetchAll' }),
    ...mapActions('dates', { getDates: 'fetchAll' }),
    ...mapActions('amenities', { getAmenities: 'fetchAll' }),
    ...mapActions('operator', { getOperator: 'fetch' }),
    ...mapActions('dispatch', { getDispatch: 'fetch' }),
    ...mapActions('email-templates', { getTemplates: 'fetchAll' }),
    ...mapActions('users', { fetchUsers: 'fetchAll' }),
    ...mapActions('vehicles', ['fetchTypes']),
    ...mapActions('stops', { fetchAllStops: 'fetchAll' })
    // ...mapActions('integrations', [ 'fetchIntegrations' ])
  }

}
</script>

<style lang="css" scoped>
</style>
